export function decodeURL(linkUrl) {
  return decodeURIComponent(linkUrl);
}
